import { render, staticRenderFns } from "./trans-issues-info.html?vue&type=template&id=5addf6f6&scoped=true&external"
import script from "./trans-issues-info.js?vue&type=script&lang=js&external"
export * from "./trans-issues-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-issues-info.scss?vue&type=style&index=0&id=5addf6f6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addf6f6",
  null
  
)

export default component.exports